<template>
<main-layout>
    <section class="form">
        <div class="form-container" id="account">
            <!-- LOADING -->
            <div class="loader" v-if="pageInfo.loading">
                <div class="spinner">
                    <div class="double-bounce1"></div>
                    <div class="double-bounce2"></div>
                </div>
                <h2>please wait ..</h2>
            </div>
            <!-- Incomplete page info -->
            <div class="notice" v-else-if="!isRegisterFlow && !inviteKey">
                <h2><b>Welcome!</b></h2>
                <p>
                  <router-link to="/register-gdpr" class="route-link">Invite company</router-link> or
                  <router-link to="/download-direct" class="route-link">Download DataMapper</router-link>
                </p>
                <!--<button @click="openSignupModal">Request Invite</button>-->
            </div>
            <signup-error v-if="shouldShowPopup"
                          v-on:hide="togglePopup"/>
            <!-- CONTENT -->
            <div v-if="!isRegisterFlow && inviteKey && !pageInfo.loading">

                <div class="grid head" v-if="progress.value < 100">


                    <div class="unit w-1-2">
                        <h3>{{pageInfo.title}} <custom-tooltip v-if="pageInfo.titleTooltip" v-bind:tooltipText="pageInfo.titleTooltip"/></h3>
                    </div>

                    <!-- BREADCRUMBS -->
                    <div class="unit w-1-2 breadcrumb">

                        <span class="link" :class="{active: process == 'account', done: done('account')}">
                            <i class="icon-check"></i> Account
                        </span>

                        <!-- GDPR ADMIN CRUMBS -->
                        <span v-if="isGDPRAdmin">

                            <span class="divider">/</span>

                            <span class="link" :class="{active: process == 'names', done: done('names')}">
                            <i class="icon-check"></i> Add names
                            </span>

                            <span class="divider">/</span>

                            <span class="link" :class="{active: process == 'gdpr-invites', done: done('gdpr-invites')}">
                            <i class="icon-check"></i> Invite colleagues
                            </span>
                        </span>
                        <!-- REGULAR ADMIN CRUMBS -->
                        <span v-else-if="isAdmin">

                            <span class="divider">/</span>

                            <span class="link" :class="{active: process == 'groups', done: done('groups')}">
                              <i class="icon-check"></i> User Groups
                            </span>

                            <span class="divider">/</span>

                            <span class="link" :class="{active: process == 'team', done: done('team')}">
                              <i class="icon-check"></i> Team
                            </span>

                        </span>

                    </div>
                </div>
                <!-- PROGRESS -->
                <div class="progress" v-if="progress.value < 100 && !isRegisterFlow">
                    <div class="bar" v-bind:style="{ width: (progress.value * 100) + '%' }"></div>
                </div>
            </div>
            <!-- STEPS CONTENT -->
            <router-view v-show="(isRegisterFlow || inviteKey) && !pageInfo.loading"></router-view>

        <!-- ERROR DISPLAY -->
        <p class="error" v-if="pageInfo.error">{{pageInfo.error}}</p>
        </div>


    </section>

    <signup-modal/>

</main-layout>

</template>

<script>
// import 'bootstrap/dist/js/bootstrap.js'

import { mapGetters, mapState } from 'vuex'
import store from './store'

// credit: https://stackoverflow.com/a/9870540
function getQueryStringValue (key) {

  const encodedKey = encodeURIComponent(key)
  // escape ., +, or *.
  // Ex: '.a+b*c' -> '\.a\+b\*c'
  const cleanedKey = encodedKey.replace(/[\.\+\*]/g, "\\$&")
  const regex = "^(?:.*[&\\?]" + cleanedKey + "(?:\\=([^&]*))?)?.*$"
  const replace = new RegExp(regex, "i")
  const all = window.location.search.replace(replace , "$1")
  return decodeURIComponent(all)
}

import MainLayout from '@/comps/MainLayout'
import SignupModal from '@/comps/SignupModal'
import SignupError from './SignupError'


export default {
    components: { MainLayout, SignupModal, SignupError },
    computed: {
        ...mapGetters(['isGDPRAdmin']),
        ...mapState([
            'pageInfo',
            'process',
            'progress'
        ]),
        ...mapState({
            isAdmin: state => state.account.isAdmin,
            isGDPR: state => state.account.isGDPR,
            inviteKey: state => state.account.inviteKey
        }),
        isRegisterFlow: function() {
            return this.$route.name === 'register-cs' ||
                this.$route.name === 'register-gdpr' ||
                this.$route.name === 'download-direct'
        },
    },

    data() {
        return {
            key: getQueryStringValue('key'),
            shouldShowPopup: false
        }
    },

    created () {
        if (this.key) this.$store.dispatch('getInviteInfo', this.key)
    },

    watch: {
        isGDPR: function(val) {
            if (val) {
                document.title = "DataMapper GDPR"
            } else {
                document.title = "DataMapper"
            }
        },
    },

    methods: {

        togglePopup() { this.shouldShowPopup = !this.shouldShowPopup },

        done (step) {
            const stepObj = this.progress.steps.find(s => s.name === step)
            return stepObj && stepObj['done']
        },
        openSignupModal() {
            this.$signupModal.open()
        }
    }
}
</script>

<style lang='scss'>


.clearfix:after {
  visibility: hidden;
  display: block;
  content: "";
  clear: both;
  height: 0;
}
* html .clearfix             { zoom: 1; } /* IE6 */
*:first-child+html .clearfix { zoom: 1; } /* IE7 */

@import '~@/assets/scss/index.scss';
@import '~vue-multiselect/dist/vue-multiselect.min.css';

$font-color: #333;

// This should be fixed somehow
.Dropdown .trigger {
  color: $font-color;
}
.Dropdown .trigger {
  padding: 0;
  color: inherit;
  text-align: left;
  min-width: 100px;
  text-transform: none;

  &:hover {
    transform: none;
  }
}


.form {
  color: $font-color;
  padding: 60px;
  min-height: 500px;
  background-color: $color-gray;

  p.error {
    color: #bb2020;
    text-align: center;
  }

  .form-container {
    // max-width: 670px;
    // min-height: 350px;
    // border-radius: 5px;
    // margin: 100px auto 0;
    // padding: 30px 30px 40px;
    // border: 1px solid #ccc;
    // background-color: #efefef;

    max-width: 1085px;
    min-height: 350px;
    border-radius: 5px;
    margin: 100px auto 0;
    padding: 30px 30px 40px;
    border: 1px solid #ccc;
    background-color: #efefef;

    h3 {
      margin: 0;
    }
  }

  .breadcrumb {
    font-size: 90%;
    cursor: default;
    padding-top: 13px;
    text-align: right;
    background-color: #efefef;
    .link {
      i {
        display: none;
        padding-right: 4px;
        vertical-align: middle;
      }
      &.done {
        font-weight: bold;
        i {
          display: inline-block;
        }
      }
    }

    .link.active {
      font-weight: bold;
      color: darken($color-blue, 10%);
    }

    .divider {
      color: #ccc;
      padding: 0 5px;
    }
  }

  .progress {
    height: 5px;
    margin: 10px;
    border-radius: 2px;
    background-color: lighten($color-blue, 40%);

    .bar {
      width: 15%;
      height: 100%;
      border-radius: 2px;
      transition: width 0.8s ease;
      background-color: $color-blue;
    }
  }

  .info {
    cursor: help;
    line-height: 1;
    padding: 0 5px;
    margin-left: 5px;
    border: 1px solid;
    color: $color-blue;
    position: relative;
    border-radius: 100%;

    .info-content {
      left: 5px;
      top: 10px;
      z-index: 1;
      width: 200px;
      color: $font-color;
      display: none;
      padding: 10px;
      cursor: default;
      font-size: 14px;
      position: absolute;
      border-radius: 3px;
      font-weight: normal;
      background-color: white;
      border: 1px solid $color-blue;
      box-shadow: 2px 3px 10px #a6b0b7;

      p:first-child {
        margin-top: 0;
      }
      p:last-child {
        margin-bottom: 0;
      }
    }

    &:hover {
      .info-content {
        display: block;
      }
    }
  }

  label {
    font-weight: normal;
    display: block;
    cursor: pointer;
    max-width: 90%;

    .smaller {
      font-size: 70%;
      float: right;
    }

    & + label {
      margin-top: 20px;
    }
  }

  input:not(.multiselect__input) {
    width: 90%;
    outline: none;
    display: block;
    line-height: 1;
    margin-top: 7px;
    border-radius: 2px;
    padding: 7px 12px;
    border: 1px solid #ccc;

    &:disabled {
      cursor: not-allowed;
      background-color: #f3f3f3;
    }

    &:focus {
      border-color: $color-blue;
    }

    &[type=checkbox] {
      margin: 0;
      width: 20px;
      height: 13px;
      display: inline-block;
    }
  }

  form {
    width: 80%;
    min-height: 250px;
    margin: 40px auto 0;

    > .grid {
      min-height: 140px;
    }
  }

  .company, .add-team {
    h4 {
      margin-bottom: 10px;
    }
    p {
      margin-top: 0;
    }
  }

  .alias {
    margin-top: 5px;

    input {
      width: 82%;
      display: inline-block;
    }

    .remove-alias {
      color: $font-color;
      cursor: pointer;
      margin-left: 3px;
    }
  }

  .add-alias, .add-mail {
    margin: 10px 0;
    display: block;
    cursor: pointer;
    color: $color-blue;
    text-align: center;
  }

  .done-section {
    width: 250px;
    margin: 50px auto 0;
    text-align: center;
  }

  .add-team {
    .logo-only {
      text-align:  center;

      img {
        width: 80px;
        margin-bottom: 20px;
      }
    }
  }

  select {
    width: 235px;
    height: 30px;
    margin-top: 7px;
  }

  button {
    min-width: 180px;
    padding: 15px 30px;
    background-color: $color-blue;
  }

  .bottom-action {
    height: 50px;
    margin-top: 20px;
    padding: 20px 20px 0;

    a {
      float: left;
      padding: 15px 0;
      color: $color-blue;
    }

    button.continue {
      float: right;
      margin-right: 10px;
    }

    button.back {
      float: right;
      margin-right: 10px;
      background-color: transparent;
      color: $color-blue;
    }

  }

  .download {
      text-align: center;

      h1 {
          margin-top: 0;
      }

      .buttons {
          margin-top: 100px;

          button {
              &:not(.current) { // current = current OS
                  display: none;
              }
              @extend %base-blue-button;
          }

      }

      img {
          width: 150px;
          margin-top: 100px;
      }
    }
  }


.notice {
  width: 400px;
  text-align: center;
  margin: 80px auto 0;

  button {
    margin-top: 40px;
  }
}
.loader {
  h2 {
    text-align: center;
    font-style: italic;
    color: $color-blue;
  }
}
.spinner {
  width: 40px;
  height: 40px;

  position: relative;
  margin: 100px auto;
}

.double-bounce1, .double-bounce2 {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-color: $color-blue;
  opacity: 0.6;
  position: absolute;
  top: 0;
  left: 0;

  -webkit-animation: sk-bounce 2.0s infinite ease-in-out;
  animation: sk-bounce 2.0s infinite ease-in-out;
}

.double-bounce2 {
  -webkit-animation-delay: -1.0s;
  animation-delay: -1.0s;
}

@-webkit-keyframes sk-bounce {
  0%, 100% { -webkit-transform: scale(0.0) }
  50% { -webkit-transform: scale(1.0) }
}

@keyframes sk-bounce {
  0%, 100% {
    transform: scale(0.0);
    -webkit-transform: scale(0.0);
  } 50% {
    transform: scale(1.0);
    -webkit-transform: scale(1.0);
  }
}

.popuptoggle {
    cursor: pointer;
}
.route-link {
  font-weight: bold;
  font-size: 1.2em;
}
@import '~archii-web-components/dist/index.css';

</style>



// WEBPACK FOOTER //
// apps/account/App.vue